"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WirelessCommonCart_1 = require("./WirelessCommonCart");
exports.default = WirelessCommonCart_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CommonCart/WirelessCommonCart/index.js
// module id = 2366
// module chunks = 8